<template>
  <div>
    <b-row>
      <b-col md="11">
        <div v-if="ams_data.attributes">
          <b-jumbotron bg-variant="dark" text-variant="white" border-variant="dark">
              <template #header>{{ams_data.attributes['event-name']}}</template>
              <template #lead>
                {{ams_data.attributes['location']}}
              </template>
              <p>
                <!-- Beginning {{ams_data.attributes['start-at']}} -->
                Starts at {{basic_scheduled_time_at}}
              </p>

              <hr text-variant="white" class="my-4">
              <p>
                Happening Now? {{ams_data.attributes['is-happening'] ? "Yes" : "No"}}
              </p>
              <template>
                <b-card md="1" bg-variant="none" body-bg-variant="dark"> {{description}}</b-card>
              </template>
              <p v-if="ams_data.attributes['end-at']">
                <!-- Ends At {{ams_data.attributes['end-at']}} -->
                Ends At {{basic_ended_time_at}}
              </p>
          </b-jumbotron>
        </div>
      </b-col>
      <b-col md="1">
        <data-navagations
          @update="doUpdate"
          @cancel="doCancel"
          @help="doHelp"
        ></data-navagations>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import {belongsToDescription, localeStringOfUTC} from '@/utils'
// import AmsCard from './AmsCard.vue'
import DataNavagations from './DataNavagations.vue'

export default {
  components: {
    // AmsCard,
    DataNavagations
  },
  props: {
    id: {
      Type: String
    }
  },
  data () {
    return {
      ams_type: 'showings',
      ams_api_path: 'api/admin/v1/',
      ams_data: {},
      basic_scheduled_time_at: undefined,
      basic_ended_time_at: undefined,
      description: undefined,
      describe_belongs_to: [
        {
          prepend: ' ',
          type: 'collections',
          description_attr: 'name',
          append: ' '
        },
        {
          prepend: ' ',
          type: 'storage-spaces',
          description_attr: 'location',
          append: ' Items'
        }
      ]
    }
  },
  computed: {
    display_scheduled_time_at() {
      return localeStringOfUTC(this.ams_data.attributes['start-at'])
    },
    display_ended_time_at() {
       return localeStringOfUTC(this.ams_data.attributes['end-at'])
    }
  },
  methods: {
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, '_') + '/' + this.id
    },
    doCancel() {
      this.$router.go(-1)
    },
    doUpdate() {
      this.$router.push( {path: '/' + this.ams_type + '/' + this.id + '/update'})
    },
    doHelp() {
      this.$router.push( {path: '/references/Showing/information/' + this.id})
    }
  },
  mounted () {
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.ams_data = response.data.data
        let scheduled_time_at = new Date(this.ams_data.attributes['start-at'])
        let ended_time_at = new Date(this.ams_data.attributes['end-at'])
        this.basic_scheduled_time_at = scheduled_time_at.toLocaleString()
        this.basic_ended_time_at = ended_time_at.toLocaleString()
        this.description = belongsToDescription(
          response.data.data, response.data.included, this.describe_belongs_to
        )
        this.$emit('gotAttrs', this.ams_data?.attributes, this.description)
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
  }
}
</script>

<style scoped>
hr { background-color: white; height: 2px; border: none; }
 .card {
     border: 3px solid white;
 }
</style>